import { render, staticRenderFns } from "./PaymentHistory.vue?vue&type=template&id=6d36d351&scoped=true&"
import script from "./PaymentHistory.vue?vue&type=script&lang=ts&"
export * from "./PaymentHistory.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentHistory.vue?vue&type=style&index=0&id=6d36d351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d36d351",
  null
  
)

export default component.exports